/*
*   @site           Preloaded: Site
*   @function       Application
*   @author         Last17
*   @copyright      Copyright 2025, Prelaoded.com
*   @version        0.01
*
*********************************************************************************************/

//-------------------------------
//  Imports
//-------------------------------

//Globals (included here to save me the heartache in each file)
import PubSub from 'pubsub-js';
import inView from 'in-view';
import fitty from 'fitty';

//Greensock
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';

//Utilities
import LayoutController from './_controllers/LayoutController';
import ImageController from './_controllers/ImageController';
import LinkController from './_controllers/LinkController';
import ModuleController from './_controllers/ModuleController';
import NavigationController from './_controllers/NavigationController';
import KeylineController from './_controllers/KeylineController';
import ItemController from './_controllers/ItemController';



//-------------------------------
//  Class Definition
//-------------------------------
class Application {
  //-----------------------------------------------
  // Constructor
  //-----------------------------------------------
  constructor() {

    //Plugin
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    //Globals
    LinkController.init(); //Keep this before the image controller as that modifies the DOM
    ImageController.init();
    LayoutController.init();
    ModuleController.init();
    KeylineController.init();
    NavigationController.init();
    ItemController.init(); //Used to manipulate generic items

    //Force page back to top on unload (why would we do this?)
    /*if(document.location.href.indexOf('localhost') === -1) {
      window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      };
    }*/

    //Fade in
    gsap.to(document.body, {opacity:1, duration: 0.3, ease:'power1.inOut'});

    //Key listeners
    if(document.location.href.indexOf('localhost') !== -1 || document.location.href.indexOf('wpengine')) {
      //Grid
      if(document.querySelector('.grid')) {
        this.grid = document.querySelector('.grid');
        window.addEventListener('keydown', (e) => {
          if(e.key.toLowerCase() === 'g') {
            (this.grid.classList.contains('show')) ? this.grid.classList.remove('show') : this.grid.classList.add('show');
          }
        });
      }

      //Wordpress
      if(document.querySelector('#wpadminbar')) {
        window.addEventListener('keydown', (e) => {
          if(e.key.toLowerCase() === 'h') {
            if(document.querySelector('#wpadminbar').classList.contains('hidden')) {
              document.querySelector('#wpadminbar').classList.remove('hidden');
              document.documentElement.classList.remove('no-admin-bar');
            } else {
              //Hiding nav bar
              document.querySelector('#wpadminbar').classList.add('hidden');
              document.documentElement.classList.add('no-admin-bar');
            }
            
          }
        });
      }
    }

    //Fit our stats
    fitty('.fit-text');
  }
}


//-------------------------------
//  Export
//-------------------------------
export default Application;